import { CardImage } from '.';
import { AppNextLink } from '../app-next-link';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { getProductURL } from '../navigation/utils/url-helpers';
interface Props {
  isLazy?: boolean;
  name: string;
  image: string;
  slug: string;
}
export const SearchCard = ({
  name,
  image,
  slug,
  isLazy = false
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const imageSize = isMobile ? 56 : 64;
  return <AppNextLink prefetch={false} href={getProductURL(slug)} className='flex items-center gap-px rounded border border-border-gray-light bg-surface-solid-0 p-1 shadow-sm focus-visible:outline-none lg:gap-1' data-sentry-element="AppNextLink" data-sentry-component="SearchCard" data-sentry-source-file="search-card.tsx">
            <CardImage alt={name} image={image} srcSet={{
      desktop: 64,
      mobile: 56
    }} isLazy={isLazy} imageClassName='h-auto w-14 aspect-square lg:w-16' parentClassName='h-fit my-auto' width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="search-card.tsx" />

            <span className='line-clamp-2 text-caption-12 text-text-black lg:text-body-14'>{name}</span>
        </AppNextLink>;
};